import { Col, Row } from "antd";
import { memo, useEffect, useState } from "react";
import { SubmitButton, TextComponent } from "../../../../../components";
import styles from "./TaskList.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { RiDeleteBinLine } from "react-icons/ri";
import { BiSolidEdit } from "react-icons/bi";
import { MdDelete } from "react-icons/md";
import Modal from "../../../../../components/modal/Modal";
import moment from "moment";
import { CheckListMiddleware } from "../../../../../Store/Middlewares/CheckListMiddleware";
import { useDispatch } from "react-redux";
import { roles } from "../../../../../config/roles";
import Storage from "../../../../../utills/AsyncStorage";

const TickSvg = (
  <svg
    className={styles.svgIcon}
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_58_2113)">
      <circle
        cx="22.8144"
        cy="22.7948"
        r="22.2284"
        fill="var(--primary-color)"
      />
    </g>
    <path
      d="M18.8263 27.352L30.5884 16.4141C30.9539 16.0742 31.4191 15.9043 31.9839 15.9043C32.5488 15.9043 33.0139 16.0742 33.3794 16.4141C33.7449 16.754 33.9277 17.1866 33.9277 17.7118C33.9277 18.2371 33.7449 18.6697 33.3794 19.0095L20.2218 31.2452C19.8231 31.6159 19.3579 31.8013 18.8263 31.8013C18.2947 31.8013 17.8295 31.6159 17.4308 31.2452L12.2475 26.4251C11.882 26.0852 11.6992 25.6526 11.6992 25.1274C11.6992 24.6021 11.882 24.1695 12.2475 23.8296C12.6129 23.4898 13.0781 23.3198 13.643 23.3198C14.2078 23.3198 14.673 23.4898 15.0385 23.8296L18.8263 27.352Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_i_58_2113"
        x="0.585938"
        y="0.566406"
        width="49.457"
        height="49.457"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="5" dy="5" />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_58_2113"
        />
      </filter>
    </defs>
  </svg>
);

const EmptySvg = (
  <svg
    className={styles.svgIcon}
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="16.8176"
      cy="17.2971"
      r="15.6887"
      fill="white"
      stroke="var(--primary-color)"
      stroke-width="1.5"
    />
  </svg>
);

const Dropdown = ({ deleteTask, task }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();

  function handleDropdown(e) {
    e.stopPropagation();
    setDropdownOpen((prev) => !prev);
  }

  useEffect(() => {
    document.body.addEventListener("click", () => setDropdownOpen(false));

    return () => {
      document.body.addEventListener("click", () => setDropdownOpen(false));
    };
  }, []);
  return (
    <>
      <TextComponent textClass={styles.dropdownBtn} onClick={handleDropdown}>
        ...
      </TextComponent>
      {dropdownOpen && (
        <Row className={styles.dropdown}>
          <Row
            className={styles.dropdownItem}
            onClick={() => setModalOpen(true)}
          >
            <RiDeleteBinLine fontSize="1.1rem" />
            <TextComponent textClass={styles.dropdownText}>
              Delete
            </TextComponent>
          </Row>
          <Row
            className={styles.dropdownItem}
            onClick={() =>
              navigate("/events/eventDetail/addNewTask", {
                state: {
                  headrTitle: "Edit Task",
                  eventData: state?.eventData,
                  task,
                },
              })
            }
          >
            <BiSolidEdit fontSize="1.1rem" />
            <TextComponent textClass={styles.dropdownText}>Edit</TextComponent>
          </Row>
        </Row>
      )}
      <Modal
        isModalOpen={modalOpen}
        setIsModalOpen={setModalOpen}
        closable={true}
        pinkBg={true}
      >
        <Row className={styles.modalContent}>
          <MdDelete className={styles.deleteIcon} />
          <TextComponent textClass={styles.modalText1}>
            Are you sure?
          </TextComponent>
          <TextComponent textClass={styles.modalText2}>
            This task will be permanently deleted
          </TextComponent>
          <SubmitButton
            onClick={() => {
              setModalOpen(false);
              deleteTask(task?.id);
            }}
            title="Remove Task"
            btnClass={styles.modalBtn}
          />
          <SubmitButton
            title="Cancel"
            outline={true}
            btnClass={styles.modalBtn}
            onClick={() => {
              setModalOpen(false);
            }}
          />
        </Row>
      </Modal>
    </>
  );
};

const SingleTask = ({
  task,
  showDueDate,
  onCompleteTask,
  onPressDeleteTask,
}) => {
  const role = Storage.getERole("@role");
  return (
    <Row className={styles.taskBox}>
      <Col className={styles.textCol}>
        <Row>
          <TextComponent
            textClass={styles.taskTitle}
            style={{
              textDecoration: task?.is_completed ? "line-through" : "none",
            }}
            onClick={
              !task?.is_completed ? () => onCompleteTask(task?.id) : null
            }
          >
            {task?.is_completed ? TickSvg : EmptySvg}
            {task?.name}
          </TextComponent>
          {task?.time ? (
            <TextComponent textClass={styles.due}>
              {task?.sub_tasks && (
                <TextComponent
                  textClass={styles.dueText}
                  text={`(${task?.sub_tasks_done}/${task?.sub_tasks?.length}) `}
                />
              )}
              {showDueDate && (
                <>
                  Due:{" "}
                  <TextComponent textClass={styles.dueText}>
                    {moment(task?.time).format("dddd DD")}
                  </TextComponent>
                </>
              )}
            </TextComponent>
          ) : (
            ""
          )}
        </Row>
        {/* {task?.sub_tasks &&
          task?.sub_tasks.map((sub) => (
            <Row className={styles.subOptionRow} key={sub?.id}>
              <Col>
                <TextComponent>
                  {sub?.is_completed ? (
                    <span
                      className={styles.subtaskTitle}
                      style={{ textDecoration: "line-through" }}
                    >
                      {TickSvg}
                      {sub.name}
                    </span>
                  ) : (
                    <span
                      className={styles.subtaskTitle}
                      onClick={() => {
                        if (roles.client == role) onCompleteTask(sub?.id);
                      }}
                    >
                      {EmptySvg}
                      {sub.name}
                    </span>
                  )}
                </TextComponent>
              </Col>
            </Row>
          ))} */}
        {task?.time ? (
          <TextComponent textClass={styles.dueSmall}>
            {task?.sub_tasks && (
              <TextComponent
                textClass={styles.dueText}
                text={`(${task?.sub_tasks_done}/${task?.sub_tasks?.length}) `}
              />
            )}
            {showDueDate && (
              <>
                Due:{" "}
                <TextComponent textClass={styles.dueTextSmall}>
                  {moment(task?.time).format("dddd DD")}
                </TextComponent>
              </>
            )}
          </TextComponent>
        ) : (
          ""
        )}
      </Col>
      {role == roles.client || role == roles.coHost ? (
        <Col className={styles.dropdownCol}>
          <Dropdown deleteTask={onPressDeleteTask} task={task} />
        </Col>
      ) : null}
    </Row>
  );
};
const TaskList = ({ tasks, showDueDate, status }) => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  console.log("taskList", tasks);
  const role = Storage.getERole("@role");
  const onPressDeleteTask = (taskId) => {
    // setdeleteModal(false);
    let checkListData = {
      task_id: taskId,
      event_id: state?.id,
      status: status,
    };
    dispatch(CheckListMiddleware.onDeleteTask(checkListData));
  };

  const onCompleteTask = (taskId) => {
    if (role == roles.client) {
      let checkListData = {
        task_id: taskId,
        event_id: state?.id,
        status: status,
      };
      dispatch(CheckListMiddleware.onCheckDone(checkListData));
    }
  };
  return (
    <>
      {tasks.map((task) => (
        <SingleTask
          key={task?.id}
          task={task}
          showDueDate={showDueDate}
          onCompleteTask={onCompleteTask}
          onPressDeleteTask={onPressDeleteTask}
        />
      ))}
    </>
  );
};

export default TaskList;
